<template>
    <div style="margin: 0 15px;">
        <navbar :title="text_title"></navbar>
        
        <input v-model="data.number" type="text" id="input" placeholder="请输入学生账号">
        <input v-model="data.code" type="text" placeholder="请输入学生密码">

        <ul>
            <li class="shenfen">请选择身份:</li>
            <li v-for="item in lists" :key="item.flok" :class="{active:item.id==data.id}"  @click="tanchu(item.id)">{{item.flok}}</li>
        </ul>

        <div class="anniu" @click="affirm">确认绑定</div>
    </div>
</template>

<script>
import navbar from './Navbar'
import URL from '../api/index'
import Vue from 'vue';
import {Toast} from 'vant';
Vue.use(Toast);
export default {
    components:{
        navbar
    },
    data(){
        return{
            text_title:"绑定学生",
            token:"",
            lists:'',
            data:{
                number:'',
                code:'',
                id:1
            }

        }
    },
    mounted(){
        this.token = JSON.parse(localStorage.getItem("userInfo"))
        if(this.token.level == "家长"){
            this.list(this.token.token)
        } 
    },
    methods:{
        list(token){
            this.$axios({
            method:'post',    
            url:URL.getkinsflok,
            data:{
                token:this.token.token
            }
            }).then((res)=>{
                this.lists = res.data.result
            })
        },
        tanchu(e){
            this.data.id= e
        },
        affirm(){
            console.log(this.data);
            this.$axios({
            method:'post',    
            url:URL.bindkinsflok,
            data:{
                token:this.token.token,
                loginname:this.data.number,
                loginpwd:this.data.code,
                flokid:this.data.id
            }
            }).then((res)=>{
                console.log(res.data.msg);
                Toast(res.data.msg)
            })   
        }
    }
}
</script>

<style  scoped>
ul{
    overflow: hidden;
}
ul li{
    float: left;
    font-size: 14px;
    margin: 6px 0;
    padding: 0 10px;
    line-height: 20px;
    cursor:pointer;
    text-align: center;
}
.shenfen{
    padding: 0;
    margin-right: 10px;
    cursor:default;
}
p{
    margin: 0;
}
input{
    width: 100%;
    border: none;
    border-bottom: 1px solid #f2f2f2;
    line-height: 44px;
    font-size: 14px;
    color: #000;
}
.anniu{
    background: #07c160;
    font-size: 16px;
    border-radius: 20px;
    text-align: center;
    line-height: 38px;
    color: #f2f2f2;
}
.active{
    background-color: #3688fc;
    color: #fff;
    border-radius: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/bangdingjiazhang.vue